import { render, staticRenderFns } from "./ArrivedRecordHistoryView.vue?vue&type=template&id=248e6ada&scoped=true&"
import script from "./ArrivedRecordHistoryView.vue?vue&type=script&lang=js&"
export * from "./ArrivedRecordHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./ArrivedRecordHistoryView.vue?vue&type=style&index=0&id=248e6ada&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e6ada",
  null
  
)

export default component.exports